
  import { Vue, Component, Prop } from "vue-property-decorator";

  import UIButton from "@/components/button/ui-button.vue";

  import UPDATE_CONTRACTOR_RATING from "@/apollo/contractors/UpdateContractorRating.gql";
  import { NOTIFICATION } from "@/entities/Events";
  import Message from "@/data/notificationsMessages";

  @Component({
    components: {
      UIButton,
    },
  })
  export default class DeleteReviewButton extends Vue {
    @Prop({ type: String, required: true }) readonly ratingId!: string;
    @Prop({ type: String, default: "Delete" }) readonly buttonText!: string;

    processing = false;

    async handleDeleteRating(): Promise<void> {
      this.$confirm({
        title: "Delete review",
        message: `Are you sure your want to delete this review`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: async (confirm: any) => {
          try {
            if (confirm) {
              this.processing = true;

              await this.$apollo.mutate({
                mutation: UPDATE_CONTRACTOR_RATING,
                variables: {
                  ratingId: this.ratingId,
                  set: { deleted: true },
                }
              });

              this.$emit('reviewDeleted');
              this.$eventBus.emit(NOTIFICATION, Message.successMessage("Review was deleted"));
            }
          } catch (e) {
            this.$eventBus.emit(NOTIFICATION, Message.errorMessage(e.message));
          } finally {
            this.processing = false;
          }
        },
      });
    }
  }
